import { IpAddress } from "../Core/IpAddress";
import { MacAddress } from "../Core/MacAddress";
import { ObjectSerializer } from "../Serialization/ObjectSerializer";
import { ValueEncoder } from "../Utils/ValueEncoder";

export class IpMacBinding implements ObjectSerializer {

	public Ip: IpAddress;
	public Mac: MacAddress;

	public constructor(ip?: IpAddress, mac?: MacAddress) {
		this.Ip = ip;
		this.Mac = mac;
	} 

	public get HasIp(): boolean {
		return !!this.Ip;
	}

	public get HasMac(): boolean {
		return !!this.Mac;
	}

	public toString(): string {
		let ipStr = (this.HasIp ? this.Ip.ToString() : "null");
		let macStr = (this.HasMac ? this.Mac.ToString() : "null");
		return "[IP: " + ipStr + ", MAC: " + macStr + "]";
	}

	public ToString(): string {
		return this.toString();
	}

	public Equals(obj: any): boolean {
		if (obj == null)
			return false;
		if (!(obj instanceof IpMacBinding))
			return false;
		let other = <IpMacBinding>obj;
		if (this.HasIp != other.HasIp)
			return false;
		if (this.HasIp)
			if (!this.Ip.Equals(other.Ip))
				return false;
		if (this.HasMac != other.HasMac)
			return false;
		if (this.HasMac)
			if (!this.Mac.Equals(other.Mac))
				return false;
		return true;
	}

	public GetHashCode(): number {
		let ipHash = (this.HasIp ? this.Ip.GetHashCode() : 0);
		let macHash = (this.HasMac ? this.Mac.GetHashCode() : 0);
		return (ipHash + macHash);
	}

	public Write(obj: any, context: any): void {
		obj.ip_mac_binding = {};
		obj = obj.ip_mac_binding;

		if (this.HasIp)
			obj.ip_address = ValueEncoder.EncodeIpAddress(this.Ip);

		if (this.HasMac)
			obj.mac_address = ValueEncoder.EncodeMacAddress(this.Mac);
	}

	public Read(obj: any, context: any): void {
		if (!obj.ip_mac_binding)
			throw new Error();
		obj = obj.ip_mac_binding;

		if (obj.ip_address !== undefined)
			this.Ip = ValueEncoder.DecodeIpAddress(obj.ip_address);

		if (obj.mac_address !== undefined)
			this.Mac = ValueEncoder.DecodeMacAddress(obj.mac_address);
	}

}